<div class="question-type__text">
  <h1 class="fs__xxl">Rank</h1>
  <p class="fs__md">You can provide a set of options for the participant to rank in their preferred order.</p>
  <p class="fs__md">Participants can drag and drop (or manually move) the options into their preferred order.</p>
</div>
